export const COMMODITIES = [
  { label: "Energy", value: "energy" },
  { label: "Grains", value: "grains" },
  { label: "Metals", value: "metals" },
  { label: "Oilseeds", value: "oilseeds" },
  { label: "Softs", value: "softs" },
];
export const DEFAULT_COMMODITY = ["grains", "oilseeds", "softs"];
export const CURRENCIES = [
  // ===== MAJOR / RESERVE CURRENCIES =====
  { label: "Majors", value: "majors" },
  // ===== LATAM =====
  { label: "Latam", value: "latam" },
  // ===== EMERGING MARKETS =====
  { label: "Emerging Markets", value: "em_fx" },
  // // ===== G10 =====
  // { label: "G10", value: "g10" },
  // // ===== ASIA =====
  // { label: "Asia", value: "asia" },
  // // ===== MIDDLE EAST =====
  // { label: "Middle East", value: "middle_east" },
  // // ===== AFRICA =====
  // { label: "Africa", value: "africa" },
  // // ===== EUROPE EMERGING =====
  // { label: "Europe Emerging", value: "europe_em" },
  // // ===== COMMODITY CURRENCIES =====
  // { label: "Commodity Fx", value: "commodity_fx" },
  // // ===== AGRICULTURE RELEVANT =====
  // { label: "Agriculture Fx", value: "agriculture_fx" },
  // // ===== ENERGY EXPORTERS =====
  // { label: "Energy Fx", value: "energy_fx" },
  // // ===== SAFE HAVENS =====
  // { label: "Safe Havens", value: "safe_haven" },
  // // ===== HIGH BETA / RISK ON =====
  // { label: "High Beta", value: "high_beta" },
  // // ===== USD PEGGED / MANAGED =====
  // { label: "USD Pegged", value: "usd_pegged" },
  // // ===== EUROPE =====
  // { label: "Europe", value: "europe" },
];
export const DEFAULT_CURRENCY = ["majors", "latam"];

export const CATEGORY_OPTIONS_2 = [
  { label: "Commodities", value: "commodities" },
  { label: "Currencies", value: "currencies" },
];

export const SHOW_FULL_CONTENT = ["Quanspire AI"];

export const COMMODITIES_DETAIL = [
  // ===== GRAINS =====
  { label: "Barley", value: "barley" },
  { label: "Corn", value: "corn" },
  { label: "Oats", value: "oats" },
  { label: "Rice", value: "rice" },
  { label: "Sorghum", value: "sorghum" },
  { label: "Wheat", value: "wheat" },
  // ===== OILSEEDS =====
  { label: "Canola", value: "canola" },
  { label: "Crude Palm Oil", value: "crude_palm_oil" },
  { label: "Crude Soybean Oil", value: "crude_soybean_oil" },
  { label: "Palm Kernel Oil", value: "palm_kernel_oil" },
  { label: "Palm Oil", value: "palm_oil" },
  { label: "Refined Palm Oil", value: "refined_palm_oil" },
  { label: "Refined Soybean Oil", value: "refined_soybean_oil" },
  { label: "Soybean", value: "soybean" },
  { label: "Soymeal", value: "soymeal" },
  { label: "Soyoil", value: "soyoil" },
  { label: "Sunflower", value: "sunflower" },
  { label: "Vegetable Oils", value: "vegetable_oils" },
  // ===== SOFTS =====
  { label: "Cocoa", value: "cocoa" },
  { label: "Coffee", value: "coffee" },
  { label: "Cotton", value: "cotton" },
  { label: "Orange Juice", value: "orange_juice" },
  { label: "Rubber", value: "rubber" },
  { label: "Sugar", value: "sugar" },
  // ===== ENERGY =====
  { label: "Brent", value: "brent" },
  { label: "Coal", value: "coal" },
  { label: "Crude Oil", value: "crude_oil" },
  { label: "Ethanol", value: "ethanol" },
  { label: "Gasoline", value: "gasoline" },
  { label: "Heating Oil", value: "heating_oil" },
  { label: "Natural Gas", value: "natural_gas" },
  { label: "WTI", value: "wti" },
  // ===== METALS =====
  { label: "Aluminum", value: "aluminum" },
  { label: "Copper", value: "copper" },
  { label: "Gold", value: "gold" },
  { label: "Lead", value: "lead" },
  { label: "Nickel", value: "nickel" },
  { label: "Palladium", value: "palladium" },
  { label: "Platinum", value: "platinum" },
  { label: "Silver", value: "silver" },
  { label: "Zinc", value: "zinc" },
];
